import React from "react";
import YouTube from 'react-youtube';
import ReactPlayer from 'react-player/vimeo'
import { observer, inject } from "mobx-react";
import { observable } from "mobx";


@inject("store")
@observer
export default class DocTypeVideo extends React.Component {

    // model props
    constructor(props) {
        super(props);
        this.tooglePlay = this.tooglePlay.bind(this);
        this.toogleLoaded = this.toogleLoaded.bind(this);
        this.extractUrlValue = this.extractUrlValue.bind(this);
        this.fetchVimeoThumbnail = this.fetchVimeoThumbnail.bind(this);
        this.state = { plays: false, loaded: false, thumbnail:null };

        this.ref = Math.random().toString(36).substr(2, 9);
    }

    tooglePlay = function () {
        this.props.store.navigation.setActiveVideo(this.ref);

        this.setState
            ({
                plays: !this.state.plays,
                loaded: false,
                playing:false

            });

    }

    componentWillReact = function () {
        if (!(this.props.model && this.props.model.autoPlay) && this.props.store.navigation.ActiveVideo !== this.ref) {
            this.setState
                ({
                    plays: false,
                    loaded: false
                });
        }
    }

    toogleLoaded = function () {
        this.setState
            ({
                loaded: !this.state.loaded
            });
    }


    extractUrlValue = function (key, url) {
        if (typeof (url) === 'undefined')
            url = window.location.href;
        var match = url.match('[?&]' + key + '=([^&]+)');
        return match ? match[1] : null;
    }

    fetchVimeoThumbnail = function(url) {
        let self = this;
        return window.fetch("https://noembed.com/embed?url=".concat(this.props.model.videoUrl)).then(function (response) {
            return response.json();
        }).then(function (data) {

            if (data.thumbnail_url && data.thumbnail_url.indexOf("_") > -1) {
                self.setState({
                    thumbnail: data.thumbnail_url.substring(0, data.thumbnail_url.indexOf("_")) + "_1900.jpg"
                });
            } else if (data.thumbnail_url) {
                self.setState({
                    thumbnail:  data.thumbnail_url.substring(0, data.thumbnail_url.indexOf(".")) + "_1900.jpg"});
            }
        });
    }

    render() {
        const imPLaying = this.props.store.navigation.ActiveVideo === this.ref; // dummy for mobx
        const autoPlay = this.props.model.autoPlay && this.props.model.autoPlay === "1" && !this.props.store.navigation.isMobile;
        const muteVideo = this.props.model.muteVideo && this.props.model.muteVideo === "1";
        
        if (this.props.model.videoUrl.indexOf("youtube") > -1) {
            let videoId = this.extractUrlValue("v", this.props.model.videoUrl);

            const opts = {
                height: '100%',
                width: '100%',
                playerVars: { // https://developers.google.com/youtube/player_parameters
                    autoplay: 1,
                    modestbranding: 1,
                    rel: 0,
                    showinfo: 0,
                    controls: autoPlay?0:1,
                    loop: autoPlay?1:0,
                    mute: autoPlay || muteVideo ? 1 : 0
                }
            };

            const thumbNailUrl =
                this.props.model.thumbnail ||
                "https://i.ytimg.com/vi/" + videoId + "/maxresdefault.jpg";

            const useThumbnailAspectRatio = this.props.model.useThumbnailRatio && this.props.model.useThumbnailRatio === "1" ? "thumbnail-aspect-ratio ": "";

            return (
                <React.Fragment>
                    {!this.state.loaded &&
                        <div className={"icom-video-container "  + useThumbnailAspectRatio + (!this.state.loaded ? "show" : "")} onClick={() =>
                            this.tooglePlay()}><img className="icom-video-frame" src={thumbNailUrl} />
                            <div className="icom-video-play-icon-container">
                                {!this.state.plays && !autoPlay &&
                                    <svg version="1.1"
                                        xmlns="http://www.w3.org/2000/svg"
                                x="0px" y="0px" width="213.7px" height="213.7px" viewBox="0 0 213.7 213.7" enableBackground="new 0 0 213.7 213.7"
                                >
                          
     <polygon className='icom-video-play-icon-triangle' id="XMLID_18_" fill="none" strokeWidth="7" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" points="73.5,62.5 148.5,105.8 73.5,149.1 " />

                                <circle className='icom-video-play-icon-circle' id="XMLID_17_" fill="none" strokeWidth="7" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" cx="106.8" cy="106.8" r="103.3" />
                                </svg> 
                                }
                                {this.state.plays &&
                                    <svg className="icom-video-play-icon" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 100 100" enableBackground="new 0 0 100 100">
                                        <path fill="#fff" d="M31.6,3.5C5.9,13.6-6.6,42.7,3.5,68.4c10.1,25.7,39.2,38.3,64.9,28.1l-3.1-7.9c-21.3,8.4-45.4-2-53.8-23.3c-8.4-21.3,2-45.4,23.3-53.8L31.6,3.5z">
                                            <animateTransform
                                                attributeName="transform"
                                                attributeType="XML"
                                                type="rotate"
                                                dur="2s"
                                                from="0 50 50"
                                                to="360 50 50"
                                                repeatCount="indefinite" />
                                        </path>
                                        <path fill="#fff" d="M42.3,39.6c5.7-4.3,13.9-3.1,18.1,2.7c4.3,5.7,3.1,13.9-2.7,18.1l4.1,5.5c8.8-6.5,10.6-19,4.1-27.7c-6.5-8.8-19-10.6-27.7-4.1L42.3,39.6z">
                                            <animateTransform
                                                attributeName="transform"
                                                attributeType="XML"
                                                type="rotate"
                                                dur="1s"
                                                from="0 50 50"
                                                to="-360 50 50"
                                                repeatCount="indefinite" />
                                        </path>
                                        <path fill="#fff" d="M82,35.7C74.1,18,53.4,10.1,35.7,18S10.1,46.6,18,64.3l7.6-3.4c-6-13.5,0-29.3,13.5-35.3s29.3,0,35.3,13.5L82,35.7z">
                                            <animateTransform
                                                attributeName="transform"
                                                attributeType="XML"
                                                type="rotate"
                                                dur="2s"
                                                from="0 50 50"
                                                to="360 50 50"
                                                repeatCount="indefinite" />
                                        </path>
                                    </svg>}
                            </div>
                        </div>
                    }
                    {(this.state.plays || autoPlay ) &&
                        <div className={"video-frame-container "}>
                        {useThumbnailAspectRatio.length > 0 && <img className="icom-video-frame" src={thumbNailUrl} style={{ visibility: 'hidden' }} /> }
                                                <YouTube
                            containerClassName={"icom-video-container " + (this.state.loaded ? "show" : "")}
                            className="icom-video-frame"
                            videoId={videoId}
                            opts={opts}
                            onEnd={() => { if (!autoPlay)this.tooglePlay();}}
                            onReady={this.toogleLoaded}
                        />
                            {autoPlay && <div style={{width:"100%",height:"100%",top: 0, left:0,position:"absolute"}}></div>}
                        </div>
}
                </React.Fragment>
            );
        } else if (this.props.model.videoUrl.indexOf("vimeo") > -1) {

            let videoId = this.props.model.videoUrl.substring(this.props.model.videoUrl.lastIndexOf("/") + 1);
            let thumbNailUrl = this.props.model.thumbnail;
            
            if (!thumbNailUrl && !this.state.thumbnail && typeof window !== 'undefined') {
                this.fetchVimeoThumbnail(this.props.model.videoUrl);
            }

            //"https://i.vimeocdn.com/video/" + videoId + "_1900.jpg";


            return (
                <React.Fragment>
                    {!this.state.loaded &&
                        <div className={"icom-video-container " + (!this.state.loaded ? "show" : "")} onClick={() =>
                            this.tooglePlay()}><img className="icom-video-frame" src={thumbNailUrl || this.state.thumbnail} />
                            <div className="icom-video-play-icon-container">
                                {!this.state.plays &&
                                    <svg version="1.1"
                                        xmlns="http://www.w3.org/2000/svg"
                                x="0px" y="0px" width="213.7px" height="213.7px" viewBox="0 0 213.7 213.7" enableBackground="new 0 0 213.7 213.7"
                                ><polygon className='icom-video-play-icon-triangle' id="XMLID_18_" fill="none" strokeWidth="7" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" points="73.5,62.5 148.5,105.8 73.5,149.1 " />

                                <circle className='icom-video-play-icon-circle' id="XMLID_17_" fill="none" strokeWidth="7" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" cx="106.8" cy="106.8" r="103.3" />
                                </svg> }
                                {this.state.plays &&
                                <svg className="icom-video-play-icon" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 100 100" enableBackground="new 0 0 100 100">
                                    <path fill="#fff" d="M31.6,3.5C5.9,13.6-6.6,42.7,3.5,68.4c10.1,25.7,39.2,38.3,64.9,28.1l-3.1-7.9c-21.3,8.4-45.4-2-53.8-23.3c-8.4-21.3,2-45.4,23.3-53.8L31.6,3.5z">
                                        <animateTransform
                                            attributeName="transform"
                                            attributeType="XML"
                                            type="rotate"
                                            dur="2s"
                                            from="0 50 50"
                                            to="360 50 50"
                                            repeatCount="indefinite" />
                                    </path>
                                    <path fill="#fff" d="M42.3,39.6c5.7-4.3,13.9-3.1,18.1,2.7c4.3,5.7,3.1,13.9-2.7,18.1l4.1,5.5c8.8-6.5,10.6-19,4.1-27.7c-6.5-8.8-19-10.6-27.7-4.1L42.3,39.6z">
                                        <animateTransform
                                            attributeName="transform"
                                            attributeType="XML"
                                            type="rotate"
                                            dur="1s"
                                            from="0 50 50"
                                            to="-360 50 50"
                                            repeatCount="indefinite" />
                                    </path>
                                    <path fill="#fff" d="M82,35.7C74.1,18,53.4,10.1,35.7,18S10.1,46.6,18,64.3l7.6-3.4c-6-13.5,0-29.3,13.5-35.3s29.3,0,35.3,13.5L82,35.7z">
                                        <animateTransform
                                            attributeName="transform"
                                            attributeType="XML"
                                            type="rotate"
                                            dur="2s"
                                            from="0 50 50"
                                            to="360 50 50"
                                            repeatCount="indefinite" />
                                    </path>
                                </svg>}
                        </div>
                        </div>
                    }
                    {(this.state.plays || autoPlay)  &&
                        <div className={"icom-video-container " + (this.state.loaded ? "show" : "")}>
                            <ReactPlayer
                                playing={this.state.playing||autoPlay}
                                controls={!autoPlay}
                                loop={autoPlay}
                                muted={autoPlay||muteVideo}
                                className="icom-video-frame"
                                url={this.props.model.videoUrl}
                                width='100%'
                                height='100%'
                                onEnded={() => { if (!autoPlay)this.tooglePlay();}}
                                onReady={this.toogleLoaded}
                            />
                            {autoPlay && <div style={{width:"100%",height:"100%",top: 0, left:0,position:"absolute"}}></div>}
                        </div>
                    }
                </React.Fragment >
            );
    } else {
    return (null);
}
    }
}